<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Dashboard</div>
		</div>
		<div class="mt-2">
			<template v-if="!loading">
				<div class="d-flex flex-wrap" >
					<v-col cols="12" class="px-0 pb-0">
						<v-row class="ml-0 mt-0">
							<v-col cols="12" sm="12" class="pl-0 pt-0 order-0" v-if="false">
								<Potency :potency="potency"/>
							</v-col>
							<v-col cols="12" sm="12" class="pa-0 order-1">
								<div class="d-flex flex-wrap">
									<v-col cols="12" sm="12" md="12" lg="12" class="">
										<TotalDownline :totalDownline="totalDownline"/>
										<!-- < !-- <TopSponsor></TopSponsor> -- > -->
									</v-col>
									<v-col cols="12" sm="12" md="12" lg="6" class="">
										<Certificate :certificate="certificate"></Certificate>
									</v-col>
									<!-- <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
										<TotalDownline :totalDownline="totalDownline"/>
									</v-col> -->
									<v-col cols="12" sm="12" md="12" lg="6" class="">
										<TenNewDownline :tenNewDownlineList="tenNewDownlineList" :slideSetting="slideSetting" />
									</v-col>
								</div>
							</v-col>
							
							<v-col cols="12" sm="12" md="12" lg="12" class="order-3">
								<NetGrowPerWeek :memberGrowList="memberGrowList" :netGrow="netGrow" /> 
							</v-col>

							<v-col cols="12" sm="12" class="pl-0 pt-0 order-4" v-if="false">
								<BankAccountInfo />
							</v-col>
						</v-row>
					</v-col>
				</div>
			</template>
			<template v-else>
				<LoaderDashboard></LoaderDashboard>
			</template>
		</div>
		<ModalInputDataMember ref="inputDataMember"></ModalInputDataMember>
		<Announcement></Announcement>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LoaderDashboard from './components/LoaderDashboard'
import Certificate from './components/Certificate'
import Potency from './components/Potency'
import BankAccountInfo from './components/BankAccountInfo'
import TotalDownline from './components/TotalDownline'
import NetGrowPerWeek from './components/NetGrowPerWeek'
import TenNewDownline from './components/TenNewDownline'
import Announcement from './components/Announcement'
// import TopSponsor from './components/TopSponsor'
import ModalInputDataMember from '@/components/modals/vo-general/ModalInputDataMember'

export default {
	components: {
		LoaderDashboard,
		Certificate,
		Potency,
		BankAccountInfo,
		TotalDownline,
		NetGrowPerWeek,
		TenNewDownline,
		Announcement,
		// TopSponsor,
		ModalInputDataMember
	},
	data() {
		return {
			loading: false,
			sellingTotal: '',
			slideSetting: {
				'dots': true,
				'infinite': true,
				'slidesToShow': 6,
				'slidesToScroll': 6,
				'vertical': true,
				'autoplay': true,
				'verticalSwiping': true
			},			
			netGrow: {
				series: [
					{
            name: 'Registrasi Ceria',
            data: []
          },
					{
            name: 'Registrasi Ekonomis',
            data: []
          },
					{
            name: 'Registrasi Premium',
            data: []
          },
					{
            name: 'Registrasi Supreme',
            data: []
          },
				],

				chartOptions: {
					colors: ['#168D0D', '#ad0757', '#2a4fd6', '#9b141b'],
					chart: {
						width: '100%',
						height: 350,
						type: 'area'
					},
					dataLabels: {
						enabled: false
					},
					stroke: {
						curve: 'smooth'
					},
					yaxis: {
						show: true,
						labels: {
							formatter: function(val) {
								return val
							}
						}
					},
					xaxis: {
						type: 'datetime',
						categories: []
					},
					tooltip: {
						x: {
							format: 'dd MMM yyyy'
						},
					},
				},
			}
		}
	},
	computed: {
		...mapState('autentikasi', ['userData', 'isAuth']),
		...mapState('dashboard', ['memberGrowList','tenNewDownlineList','potency','totalDownline', 'certificate']),
	},
	methods: {
		...mapActions('dashboard', ['getMemberGrow','getTenNewDownline','getPotency','getTotalDownline', 'getCertificate']),

		async getData() {
			this.loading = await true
			this.getCertificate()
			this.getTenNewDownline()
			this.getPotency()
			this.getTotalDownline()
			await this.getMemberGrow().then(() => {
				if (this.memberGrowList) this.setNetgrowSummaries(this.memberGrowList)
			})
			setTimeout(() => {
				this.loading = false
			}, 300)
			if (this.isAuth && this.userData.member_network_updated == '0') {
				this.$refs.inputDataMember.modalShow()
			}
		},
		// async setResumeSelling(data) {
		// 	this.resumeSellingChart.series[0].data = await data.map((el) => el['value'])
		// 	this.resumeSellingChart.chartOptions.xaxis.categories = await data.map((el) => el['month'])
		// },
		// async setResumeBuying(data) {
		// 	this.resumeBuyingChart.series[0].data = await data.map((el) => el['value'])
		// 	this.resumeBuyingChart.chartOptions.xaxis.categories = await data.map((el) => el['month'])
		// },
		async setNetgrowSummaries(data) {
			this.netGrow.series[0].data = await data.map((el) => el['member_registration_ceria'])
			this.netGrow.series[1].data = await data.map((el) => el['member_registration_ekonomi'])
			this.netGrow.series[2].data = await data.map((el) => el['member_registration'])
			this.netGrow.series[3].data = await data.map((el) => el['member_registration_supreme'])
			// this.netGrow.series[1].data = await data.map((el) => el['member_activation'])
			this.netGrow.chartOptions.xaxis.categories = await data.map((el) => el['member_date'])
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Dashboard`)
		this.getData()
	}
};
</script>

<style lang="scss">
.serial-list {
	margin-top: 7px;
	li {
		line-height: 1.1;
	}
}
.rank-text {
	background: rgba(255,255,255, 0.85);
	border-radius: 25px;
}
.text-sm-center {
	text-align: left;
}
@media (max-width: 599px) {
	.text-sm-center {
		text-align: center;
	}
}
</style>